import React from 'react';

export default function AssignmentToolbar({
  canCreate,
  search,
  onSearch,
  statusFilter,
  onStatusFilter,
  dueFilter,
  onDueFilter,
  showArchived,
  onShowArchived,
  onAdd,
}) {
  return (
    <div className="bg-white rounded-lg shadow p-4 mb-4">
      <div className="flex flex-col lg:flex-row lg:items-center gap-3">
        <input
          value={search}
          onChange={(event) => onSearch(event.target.value)}
          placeholder="Search client, assignment, staff, FY, period or remarks..."
          className="flex-1 px-3 py-2 border rounded"
        />
        <select value={statusFilter} onChange={(event) => onStatusFilter(event.target.value)} className="px-3 py-2 border rounded">
          <option value="all">All Statuses</option>
          <option value="Pending">Pending</option>
          <option value="In Progress">In Progress</option>
          <option value="Completed">Completed</option>
        </select>
        <select value={dueFilter} onChange={(event) => onDueFilter(event.target.value)} className="px-3 py-2 border rounded">
          <option value="all">All Due Dates</option>
          <option value="today">Due Today</option>
          <option value="overdue">Overdue</option>
          <option value="upcoming">Upcoming</option>
          <option value="none">No Due Date</option>
        </select>
        <label className="flex items-center gap-2 whitespace-nowrap text-sm">
          <input type="checkbox" checked={showArchived} onChange={(event) => onShowArchived(event.target.checked)} />
          Show archived
        </label>
        {canCreate && (
          <button onClick={onAdd} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 whitespace-nowrap">
            + Add Assignment
          </button>
        )}
      </div>
    </div>
  );
}
